export const clientBaseUrl = process.env.REACT_APP_CLIENT_BASE_URL as string
export const serverBaseUrl = process.env.REACT_APP_SERVER_BASE_URL as string
export const mapboxAccessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN as string
